// extracted by mini-css-extract-plugin
export default {"dark":"MenuIcon--dark--WpTa0","light":"MenuIcon--light--hAAv3","menuIcon":"MenuIcon--menuIcon--UdFXM","bar":"MenuIcon--bar--9aQEM","isOpen":"MenuIcon--isOpen--b+nwr"};